const formatExampleReference = (schemaName: string): string => `#/components/examples/${schemaName}`;

export default formatExampleReference;
